import { render, staticRenderFns } from "./SettingMemberShip.vue?vue&type=template&id=70e01a6c&"
import script from "./SettingMemberShip.vue?vue&type=script&lang=js&"
export * from "./SettingMemberShip.vue?vue&type=script&lang=js&"
import style0 from "./SettingMemberShip.vue?vue&type=style&index=0&id=70e01a6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports